<template>
  <div>
    <div class="content-header"></div>
    <div class="content-wrapper">
      <el-row>
        <el-col :span="7" class="content-left">
          <IndexMenu />
        </el-col>

        <el-col :span="17" class="content-right">
          <el-card class="content-right-top content-workspace" shadow="never" v-if="canISPHigh">
            <div class="card-title">超高端项目</div>
            <div class="menu-row">
              <div class="card-box card-margin">
                <el-card shadow="hover">
                  <router-link to="/isp/quota-info">
                    <div class="card-icon">
                      <img style="width: 36px" src="../../assets/images/isp-quota.png" />
                    </div>
                    <div class="card-text">配额管理</div>
                  </router-link>
                </el-card>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import IndexMenu from './components/index-menu'
import tradeApi from '@/api/trade'
import { mapGetters } from 'vuex'
import { localStorageUtils } from '@/utils/localstorage'
export default {
  name: 'home',
  components: {
    IndexMenu
  },
  data () {
    return {
      employeeLevel: '',
      defaultBuType: '',
      queryType: '01',
      collectList: [],
      todoInfo: '',

      currentOffset: 0,
      windowSize: 5,
      paginationFactor: 155,
      queryParams: {
        page: 1,
        pageSize: 10,
        applyType: '',
        applyStatus: '',
        solutionStatus: '',
        acceptanceStatus: '',
        requirementStatus: '',
        executionStatus: '',
        isOwner: '',
        pledgePaid: '',
        applyClientLevel: '',
        queryType: '',
        queryRegionCode: '',
        queryBuCode: '',
        tradeStackWeek: '',
        tradeStackWeekStatus: '',
        waitClockIn: '',
        stackSpecs: '',
        applyNumber: '',
        vendorName: '',
        pocName: '',
        pocCode: '',
        execType: '',
        execTypeSub: '',
        isAll: '',
        keyword: '',
        orderCol: '',
        orderMethod: '',
        applyTypeTemp: '',
        applyStatusTemp: '',
        clientType: '',
        sievingDisablePoc: ''
      },
      listLoading: false,
      activeTodo: 0,
      projectPermission: {
        lemonOrder: 0,
        lemonStatistics: 0,
        dcofApply: 0,
        dcofParentView: 0,
        dcofView: 0
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),

    // 是否可以提报批量化物料
    canApply () {
      return (this.employeeLevel === 45 || this.employeeLevel === 50 || this.employeeLevel === 60)
    },

    canTheme () {
      return (this.employeeLevel === 45 || this.employeeLevel === 50 || (this.employeeLevel === 60 && this.defaultBuType === '01') || (this.employeeLevel === 90 && this.defaultBuType === '01'))
    },

    atEndOfList () {
      return this.currentOffset <= (this.paginationFactor * -1) * (this.filterCollectList.length - this.windowSize)
    },
    atHeadOfList () {
      return this.currentOffset === 0
    },

    filterCollectList () {
      let list = this.collectList
      if (!this.projectPermission.lemonStatistics) {
        list = this.collectList.filter((item) => {
          return item.execTypeSub !== "109"
        })
      }
      if (!this.projectPermission.dcofView) {
        list = this.collectList.filter((item) => {
          return item.execTypeSub !== "121"
        })
      }
      return list
    },
    toPerfectUrl () {
      let url = ''
      switch (this.employeeLevel) {
        case 50:
          url = '/trade/perfect-region-config-list'
          break
        case 60:
          url = '/trade/perfect-bu-config-list'
          break
        case 90:
          url = '/trade/perfect-hq-config-list'
          break
      }
      return url
    },
    canISPHigh () {
      return ['28063811', '28062577', '28077456', '28051023', '28070610' ].includes(this.userInfo.employeeCode)
    }
  },
  created () {
    this.employeeLevel = this.userInfo.employeeLevel
    this.defaultBuType = this.userInfo.defaultBuType
    localStorageUtils.remove('queryParams')

    this.getCollect()
    this.getTodo()
    this.getProjectPermission()
  },
  methods: {
    // 获取进度
    getCollect () {
      const params = {
        queryType: this.queryType
      }
      this.listLoading = true
      this.$store.dispatch('getCollect', params).then(res => {
        this.listLoading = false
        if (res.data.resultCode === '0') {
          if (res.data.resultData.tradeApplyCollectList) {
            if (this.employeeLevel < 40) {
              // 40以下看不到批量化物料
              res.data.resultData.tradeApplyCollectList.forEach((item) => {
                if (item.execTypeSub !== '02') this.collectList.push(item)
              })
            } else {
              this.collectList = res.data.resultData.tradeApplyCollectList
            }
            // 屏蔽品质堆箱
            if (this.collectList.length) {
              let arr = this.collectList.filter(item => {
                return item.execTypeSub !== '103'
              })
              this.collectList = arr
            }

            // 级别 60 70 80 且 bu不为南区，或 级别为 40 45 50 region不为惠州、广东西区 的用户 不显示PBO进度
            if (((this.employeeLevel === 60 || this.employeeLevel === 70 || this.employeeLevel === 80) &&
              this.userInfo.buCode !== '58') ||
              ((this.employeeLevel === 40 || this.employeeLevel === 45 || this.employeeLevel === 50) &&
                (this.userInfo.regionCode !== '286' && this.userInfo.regionCode !== '236' && this.userInfo.regionCode !== '300'))
            ) {
              // 剔除PBO进度
              this.collectList = this.collectList.filter(item => {
                return item.execTypeSub !== '106'
              })
            }
          }
        }
      }).catch(() => {
        this.listLoading = false
      })
    },

    // 待办统计
    getTodo () {
      const params = {
        queryType: '01'
      }
      this.$store.dispatch('getTodo', params).then(res => {
        if (res.data.resultCode === '0') {
          this.todoInfo = res.data.resultData.tradeApplyTodoInfo
        }
      })
      if (this.employeeLevel === 60 && this.canTheme) {
        tradeApi.activeTodo().then(res => {
          if (res.data.resultCode === '0') {
            this.activeTodo = res.data.resultData.tradePerfectThemeDefineApproveCount
          }
        })
      }
    },
    typeChange () {
      this.getCollect()
    },

    moveCarousel (direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor
      }
    },

    // 进展中
    handleViewList (item, val) {
      this.queryParams.sievingDisablePoc = 1
      this.queryParams.applyTypeTemp = item.execTypeSub
      if (item.execTypeSub === '02') {
        this.queryParams.applyType = item.execTypeSub
      } else {
        this.queryParams.execTypeSub = item.execTypeSub
      }
      this.queryParams.queryType = this.queryType
      if (val) {
        if (item.execTypeSub === '121') {
          this.queryParams.applyStatus = '100',
            this.queryParams.applyStatusList = ''
        } else if (item.execTypeSub === '105') {
          this.queryParams.applyStatus = ''
          this.queryParams.applyStatusList = '0,100,200,'
        } else {
          this.queryParams.applyStatus = ''
          this.queryParams.applyStatusList = '0,100,200,300,400'
        }
      } else {
        if (item.execTypeSub === '121') {
          this.queryParams.applyStatus = ''
          this.queryParams.applyStatusList = '300,500'
        } else {
          this.queryParams.applyStatus = '500'
          this.queryParams.applyStatusList = ''
        }
      }
      localStorageUtils.set('queryParams', JSON.stringify(this.queryParams))
      this.$router.push({
        path: '/trade/order/all'
      })
    },

    // 获取项目权限
    async getProjectPermission () {
      const { data } = await this.$store.dispatch('getProjectPermission')
      if (data.resultCode === '0') {
        const { resultData } = data
        resultData.dcofApply = resultData['dcof:sales']
        resultData.dcofParentView = resultData['dcof:sales:parent']
        resultData.dcofView = resultData['dcof:statistics']
        this.projectPermission = resultData
        localStorageUtils.set("projectPermission", JSON.stringify(this.projectPermission))
      }
    },
    toConfig () {
      // '28056757', '28065973'
      if ([].includes(this.userInfo.employeeCode)) {
        this.$message.warning('当前账号暂未开放尊享陈列活动配置')
        return
      } else {
        let url = ''
        switch (this.employeeLevel) {
          case 50:
            url = '/trade/perfect-region-config-list'
            break
          case 60:
            url = '/trade/perfect-bu-config-list'
            break
          case 90:
            url = '/trade/perfect-hq-config-list'
            break
        }
        this.$router.push({
          path: url
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content-header {
  height: 100px;
  background: url('../../assets/images/banner-menu.jpg') center no-repeat;
  background-size: cover;
}
.content-wrapper {
  min-height: calc(100vh - 320px) !important;

  .card-title {
    font-size: $font-16;

    .card-radio {
      position: absolute;
      right: 30px;
      top: 10px;

      ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: $base-red;
        border-color: $base-red;
        box-shadow: -1px 0 0 0 $base-red;
      }
      ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner:hover {
        color: $base-white;
      }

      ::v-deep .el-radio-button__inner:hover {
        color: $base-red;
      }
    }
  }

  .content-left,
  .content-right {
    height: 850px;
    box-sizing: border-box;
    a {
      text-decoration: none;
      color: #000;
    }
  }

  .content-left {
    padding-right: $content-middle;
  }

  .content-workspace {
    height: auto !important;
  }

  .content-right-top {
    width: 100%;
    height: 300px;
    margin-bottom: 18px;
    .card-title {
      position: relative;
      padding: 17px;
      border-bottom: 1px solid $base-grey2;
    }
    .menu-row {
      display: flex;
      padding: 0 60px 35px 60px;
      // justify-content: space-between;
      flex-wrap: wrap;

      .card-metrial {
        border-right: 1.5px dashed #aaa;
        padding-right: 30px;
        padding-top: 10px;
        margin-top: -10px;
        margin-bottom: -10px;
      }

      .card-box {
        min-width: 150px;
        position: relative;
        margin-top: 35px;
        ::v-deep .el-badge {
          position: absolute;
          top: -2px;
          right: -10px;

          // .el-badge__content--danger {
          //   background-color: $base-red;
          // }

          .el-badge__content {
            font-size: 14px;
            height: 22px;
            line-height: 23px;
            border-radius: 12px;
            padding: 0 8px;
          }
        }
      }
      .card-margin {
        margin-right: 30px;
      }

      .el-card {
        width: 150px;
        height: 180px;
        cursor: pointer;
        text-align: center;
        .card-icon {
          padding: 50px 0 10px 0;
          margin-bottom: $content-middle;
          height: 40px;
          .iconfont {
            font-size: 36px;
            transition: all 0.4s;
          }
        }
        .card-text {
          font-size: $font-16;
        }
      }
    }
  }
}
.iconzu6 {
  color: $base-red;
}
.iconzu7 {
  color: $base-yellow;
}
.iconzu8 {
  color: $base-pink;
}
.iconzu10 {
  color: $base-yellow;
}
.iconzu9 {
  color: $base-olive;
}
.icontupian {
  color: $base-blue;
}
.iconzu11 {
  color: $base-teal;
}

.menu-row-project {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0 40px;
  color: #666a73;
  height: 240px;

  .card-carousel {
    display: flex;
    justify-content: center;
    width: 750px;
  }

  .card-carousel--overflow-container {
    overflow: hidden;
  }

  .card-carousel-cards {
    display: flex;
    transition: transform 0.25s ease-out;
    transform: translatex(0px);
    height: 210px;
    text-align: center;
    box-sizing: border-box;
  }

  .card-carousel--card {
    margin: 0 15px;
    background-color: #fff;
    border-radius: 4px;
    z-index: 3;
    margin-bottom: 2px;
    flex-shrink: 0;
    width: 125px;

    .coll-name {
      font-weight: bold;
      padding-top: 10px;
      font-size: 16px;
    }

    .coll-box {
      width: 100%;
      height: 130px;
      border: 1px solid #ddd;
      margin-top: 15px;
      border-radius: 8px;
      box-sizing: border-box;
      padding-top: 20px;

      .coll-box-num {
        font-weight: bold;
        margin-top: 18px;
        cursor: pointer;

        span {
          color: $base-red;
          padding-left: 5px;
        }
      }

      .coll-box-num:hover {
        color: $base-red;
      }
    }

    &:first-child {
      margin-left: 5px;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}

.menu-row-btn-left,
.menu-row-btn-left-right {
  display: inline-block;
  width: 15px;
  height: 15px;
  padding: 8px;
  box-sizing: border-box;
  border-top: 3px solid $base-red;
  border-right: 3px solid $base-red;
  cursor: pointer;
  margin: 0 10px;
  transition: transform 0.2s linear;
}
.menu-row-btn-left[disabled],
.menu-row-btn-left-right[disabled] {
  opacity: 0.2;
  border-color: black;
  cursor: not-allowed;
}
.menu-row-btn-left {
  transform: rotate(-135deg);
}
.menu-row-btn-left:active {
  transform: rotate(-135deg) scale(0.85);
}
.menu-row-btn-left-right {
  transform: rotate(45deg);
}
.menu-row-btn-left-right:active {
  transform: rotate(45deg) scale(0.85);
}
</style>
